<template>
    <div class="a-dropdown dropdown">
        <Select
            v-model="localValue"
            :prefix="`dropdown__header-icon--${localValue}`"
            @on-open-change="handleOpenChange"
            @on-change="handleChange"
        >
            <Option
                v-for="item in items"
                :key="item[keyField]"
                :at-a-dropdown-options="item[keyField]"
                :value="item[keyField]"
                :label="item[nameField]"
                :class="{'hide-option': item[keyField] === value }"
                :disabled="item[keyField] === value"
            >
                <div class="dropdown__inner-block">
                    <svg-icon
                        original
                        :name="`locales/${item.value}`"
                        class="dropdown__icon"
                    />
                    <span  class="dropdown__text">
                        {{ item.label }}
                    </span>
                </div>
            </Option>
        </Select>
    </div>
</template>
<script>

export default {
    name: 'ADropdown',
    props: {
        value: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default: () => []
        },
        nameField: {
            type: String,
            default: 'name'
        },
        keyField: {
            type: String,
            default: 'id'
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        }
    },
    methods: {
        handleOpenChange(e) {
            this.$emit('onOpenChange', e);
        },
        handleChange(e) {
            this.$emit('onChange', e);
        }
    }
};
</script>

<style lang="scss">
@import "a-dropdown.scss";
</style>
